import { isNotNullOrUndef } from '../../utils/isNotNullOrUndef';
const createStringVNode = (text, parentVNode) => {
    return {
        type: 'STRING',
        parentVNode,
        text,
        _el: undefined
    };
};
const createHTMLVNode = (html, parentVNode) => {
    return {
        type: 'HTML',
        parentVNode,
        html,
        _el: undefined
    };
};
const createElementVNode = (tag, attributes, children, parentVNode) => {
    const vNode = {
        tag,
        parentVNode,
        type: 'ELEMENT',
        key: null,
        props: {},
        propsArray: [],
        hiddenProps: {},
        hiddenPropsArray: [],
        children: [],
        events: {},
        eventsArray: [],
        lifeEvents: {},
        _el: undefined
    };
    vNode.children = children.reduce((arr, child) => {
        if (child === null || child === undefined || child === false) {
            return arr;
        }
        if (typeof child === 'object') {
            child.parentVNode = vNode;
            arr.push(child);
        }
        else if (typeof child === 'number') {
            arr.push(createStringVNode(String(child), vNode));
        }
        else if (child.includes('</')) {
            arr.push(createHTMLVNode(child, vNode));
        }
        else {
            arr.push(createStringVNode(child, vNode));
        }
        return arr;
    }, []);
    Object.keys(attributes).forEach(key => {
        switch (key) {
            case 'key':
                vNode.key = String(attributes.key);
                break;
            case 'data':
                Object.entries(attributes.data).forEach(([name, value]) => {
                    name = `data-${name.replace(/[A-Z]/g, '-$&').toLowerCase()}`;
                    vNode.props[name] = value;
                    vNode.propsArray.push({ key: name, value });
                });
                break;
            case 'events':
                vNode.events = attributes.events;
                Object.entries(attributes.events).forEach(([key, event]) => {
                    vNode.eventsArray.push({ key, event });
                });
                break;
            case 'hiddenProperties':
                vNode.hiddenProps = attributes.hiddenProperties;
                Object.entries(attributes.hiddenProperties).forEach(([key, value]) => {
                    vNode.hiddenPropsArray.push({ key, value });
                });
                break;
            case 'didMount':
            case 'didUpdate':
            case 'willUpdate':
            case 'willUnmount':
                vNode.lifeEvents[key] = attributes[key];
                break;
            case 'didMountOrUpdate':
                vNode.lifeEvents.didMount = attributes[key];
                vNode.lifeEvents.didUpdate = attributes[key];
                break;
            case 'didUnmount':
                vNode.lifeEvents[key] = attributes[key];
                break;
            default:
                if (key.startsWith('_')) {
                    vNode.hiddenProps[key] = attributes[key];
                    vNode.hiddenPropsArray.push({ key, value: attributes[key] });
                }
                else {
                    vNode.props[key] = attributes[key];
                    vNode.propsArray.push({ key, value: attributes[key] });
                }
        }
    });
    return vNode;
};
export const vNodeCreate = (tag, attributes, children) => {
    let attr = {};
    let ch = [];
    if (isNotNullOrUndef(attributes) && attributes !== false) {
        if (attributes instanceof Array) {
            ch = attributes;
        }
        else if (typeof attributes === 'string' || typeof attributes === 'number') {
            ch = [attributes];
        }
        else if (typeof attributes.parentVNode === 'object') {
            ch = [attributes];
        }
        else {
            attr = attributes;
        }
    }
    if (isNotNullOrUndef(children) && children !== false) {
        if (children instanceof Array) {
            ch = children;
        }
        else {
            ch = [children];
        }
    }
    return createElementVNode(tag, attr, ch, null);
};
